export enum TriggerType {
  UNSET_TRIGGER_TYPE = 'UNSET_TRIGGER_TYPE',
  NOTIFICATION = 'NOTIFICATION',
}
